import { render } from "./RoleEdit.vue?vue&type=template&id=31dbc139&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"

import "./RoleEdit.vue?vue&type=style&index=0&id=31dbc139&lang=scss&scoped=true"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dbc139"]])

export default __exports__